import _regeneratorRuntime from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { scalar } from '@tensorflow/tfjs-core';
import { TensorArray } from '../../executor/tensor_array';
import { fromTensor, reserve, scatter, split } from '../../executor/tensor_list';
import { cloneTensor, getParamValue, getTensor } from './utils';
export var executeOp = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(node, tensorMap, context) {
    var thenFunc, elseFunc, cond, args, condValue, _ret, pred, _pred, data, inputName, _data, frameId, _data2, _data3, _data4, size, dtype, elementShape, dynamicSize, clearAfterRead, identicalElementShapes, name, tensorArray, id, index, writeTensor, writeTensorArray, readId, readIndex, readTensorArray, gatherId, gatherIndices, gatherDtype, gatherTensorArray, scatterId, scatterIndices, scatterTensor, scatterTensorArray, concatId, concatTensorArray, concatDtype, splitId, splitTensor, lengths, splitTensorArray, sizeId, sizeTensorArray, closeId, closeTensorArray, idTensor, _index, _writeTensor, tensorList, _idTensor, _readIndex, _elementShape, elementDType, _tensorList, _scatterIndices, _scatterTensor, _elementShape2, numElements, _tensorList2, _elementShape3, elementDtype, numElementsParam, _numElements, _tensorList3, _gatherId, _gatherIndices, _elementShape4, _elementDtype, _tensorList4, _idTensor2, _elementShape5, _elementDtype2, _numElements2, _tensorList5, tensor, _elementShape6, _elementDtype3, _tensorList6, _concatId, _tensorList7, _concatDtype, _elementShape7, _idTensor3, _writeTensor2, _tensorList8, _idTensor4, _elementShape8, _elementDType, _tensorList9, _splitTensor, _elementShape9, _lengths, _tensorList10;

    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.t0 = node.op;
            _context3.next = _context3.t0 === 'If' ? 3 : _context3.t0 === 'StatelessIf' ? 3 : _context3.t0 === 'While' ? 15 : _context3.t0 === 'StatelessWhile' ? 15 : _context3.t0 === 'LoopCond' ? 19 : _context3.t0 === 'Switch' ? 21 : _context3.t0 === 'Merge' ? 32 : _context3.t0 === 'Enter' ? 37 : _context3.t0 === 'Exit' ? 41 : _context3.t0 === 'NextIteration' ? 44 : _context3.t0 === 'TensorArrayV3' ? 47 : _context3.t0 === 'TensorArrayWriteV3' ? 57 : _context3.t0 === 'TensorArrayReadV3' ? 63 : _context3.t0 === 'TensorArrayGatherV3' ? 67 : _context3.t0 === 'TensorArrayScatterV3' ? 72 : _context3.t0 === 'TensorArrayConcatV3' ? 78 : _context3.t0 === 'TensorArraySplitV3' ? 82 : _context3.t0 === 'TensorArraySizeV3' ? 88 : _context3.t0 === 'TensorArrayCloseV3' ? 91 : _context3.t0 === 'TensorListSetItem' ? 95 : _context3.t0 === 'TensorListGetItem' ? 101 : _context3.t0 === 'TensorListScatterV2' ? 107 : _context3.t0 === 'TensorListScatter' ? 107 : _context3.t0 === 'TensorListReserve' ? 114 : _context3.t0 === 'EmptyTensorList' ? 114 : _context3.t0 === 'TensorListGather' ? 121 : _context3.t0 === 'TensorListStack' ? 127 : _context3.t0 === 'TensorListFromTensor' ? 133 : _context3.t0 === 'TensorListConcat' ? 139 : _context3.t0 === 'TensorListPushBack' ? 144 : _context3.t0 === 'TensorListPopBack' ? 149 : _context3.t0 === 'TensorListSplit' ? 154 : 160;
            break;

          case 3:
            thenFunc = getParamValue('thenBranch', node, tensorMap, context);
            elseFunc = getParamValue('elseBranch', node, tensorMap, context);
            cond = getParamValue('cond', node, tensorMap, context);
            args = getParamValue('args', node, tensorMap, context);
            _context3.next = 9;
            return cond.data();

          case 9:
            condValue = _context3.sent;

            if (!condValue[0]) {
              _context3.next = 14;
              break;
            }

            return _context3.abrupt("return", context.functionMap[thenFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap));

          case 14:
            return _context3.abrupt("return", context.functionMap[elseFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap));

          case 15:
            return _context3.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var bodyFunc, condFunc, args, condResult, argIds, condValue, result, _loop;

              return _regeneratorRuntime.wrap(function _callee$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      bodyFunc = getParamValue('body', node, tensorMap, context);
                      condFunc = getParamValue('cond', node, tensorMap, context);
                      args = getParamValue('args', node, tensorMap, context); // Calculate the condition of the loop

                      _context2.next = 5;
                      return context.functionMap[condFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap);

                    case 5:
                      condResult = _context2.sent;
                      argIds = args.map(function (tensor) {
                        return tensor.id;
                      });
                      _context2.next = 9;
                      return condResult[0].data();

                    case 9:
                      condValue = _context2.sent;
                      // Dispose the intermediate tensors for condition function
                      condResult.forEach(function (tensor) {
                        if (!tensor.kept && argIds.indexOf(tensor.id) === -1) {
                          tensor.dispose();
                        }
                      });
                      result = args;
                      _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                        var origResult, resultIds, condResult;
                        return _regeneratorRuntime.wrap(function _loop$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                // Record the previous result for intermediate tensor tracking
                                origResult = result; // Execution the body of the loop

                                _context.next = 3;
                                return context.functionMap[bodyFunc].executeFunctionAsync(result, context.tensorArrayMap, context.tensorListMap);

                              case 3:
                                result = _context.sent;
                                resultIds = result.map(function (tensor) {
                                  return tensor.id;
                                }); // Dispose the intermediate tensor for body function that is not global
                                // kept, not input/output of the body function

                                origResult.forEach(function (tensor) {
                                  if (!tensor.kept && argIds.indexOf(tensor.id) === -1 && resultIds.indexOf(tensor.id) === -1) {
                                    tensor.dispose();
                                  }
                                }); // Recalcuate the condition of the loop using the latest results.

                                _context.next = 8;
                                return context.functionMap[condFunc].executeFunctionAsync(result, context.tensorArrayMap, context.tensorListMap);

                              case 8:
                                condResult = _context.sent;
                                _context.next = 11;
                                return condResult[0].data();

                              case 11:
                                condValue = _context.sent;
                                // Dispose the intermediate tensors for condition function
                                condResult.forEach(function (tensor) {
                                  if (!tensor.kept && argIds.indexOf(tensor.id) === -1 && resultIds.indexOf(tensor.id) === -1) {
                                    tensor.dispose();
                                  }
                                });

                              case 13:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _loop);
                      });

                    case 13:
                      if (!condValue[0]) {
                        _context2.next = 17;
                        break;
                      }

                      return _context2.delegateYield(_loop(), "t0", 15);

                    case 15:
                      _context2.next = 13;
                      break;

                    case 17:
                      return _context2.abrupt("return", {
                        v: result
                      });

                    case 18:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee);
            })(), "t1", 16);

          case 16:
            _ret = _context3.t1;

            if (!(typeof _ret === "object")) {
              _context3.next = 19;
              break;
            }

            return _context3.abrupt("return", _ret.v);

          case 19:
            pred = getParamValue('pred', node, tensorMap, context);
            return _context3.abrupt("return", [cloneTensor(pred)]);

          case 21:
            _pred = getParamValue('pred', node, tensorMap, context);
            data = getParamValue('data', node, tensorMap, context);

            if (!data.kept) {
              data = cloneTensor(data);
            } // Outputs nodes :0 => false, :1 => true


            _context3.next = 26;
            return _pred.data();

          case 26:
            if (!_context3.sent[0]) {
              _context3.next = 30;
              break;
            }

            _context3.t2 = [undefined, data];
            _context3.next = 31;
            break;

          case 30:
            _context3.t2 = [data, undefined];

          case 31:
            return _context3.abrupt("return", _context3.t2);

          case 32:
            inputName = node.inputNames.find(function (name) {
              return getTensor(name, tensorMap, context) !== undefined;
            });

            if (!inputName) {
              _context3.next = 36;
              break;
            }

            _data = getTensor(inputName, tensorMap, context);
            return _context3.abrupt("return", [cloneTensor(_data)]);

          case 36:
            return _context3.abrupt("return", undefined);

          case 37:
            frameId = getParamValue('frameName', node, tensorMap, context);
            _data2 = getParamValue('tensor', node, tensorMap, context);
            context.enterFrame(frameId);
            return _context3.abrupt("return", [cloneTensor(_data2)]);

          case 41:
            _data3 = getParamValue('tensor', node, tensorMap, context);
            context.exitFrame();
            return _context3.abrupt("return", [cloneTensor(_data3)]);

          case 44:
            _data4 = getParamValue('tensor', node, tensorMap, context);
            context.nextIteration();
            return _context3.abrupt("return", [cloneTensor(_data4)]);

          case 47:
            size = getParamValue('size', node, tensorMap, context);
            dtype = getParamValue('dtype', node, tensorMap, context);
            elementShape = getParamValue('elementShape', node, tensorMap, context);
            dynamicSize = getParamValue('dynamicSize', node, tensorMap, context);
            clearAfterRead = getParamValue('clearAfterRead', node, tensorMap, context);
            identicalElementShapes = getParamValue('identicalElementShapes', node, tensorMap, context);
            name = getParamValue('name', node, tensorMap, context);
            tensorArray = new TensorArray(name, dtype, size, elementShape, identicalElementShapes, dynamicSize, clearAfterRead);
            context.addTensorArray(tensorArray);
            return _context3.abrupt("return", [tensorArray.idTensor, scalar(1.0)]);

          case 57:
            id = getParamValue('tensorArrayId', node, tensorMap, context);
            index = getParamValue('index', node, tensorMap, context);
            writeTensor = getParamValue('tensor', node, tensorMap, context);
            writeTensorArray = context.getTensorArray(id.id);
            writeTensorArray.write(index, writeTensor);
            return _context3.abrupt("return", [writeTensorArray.idTensor]);

          case 63:
            readId = getParamValue('tensorArrayId', node, tensorMap, context);
            readIndex = getParamValue('index', node, tensorMap, context);
            readTensorArray = context.getTensorArray(readId.id);
            return _context3.abrupt("return", [readTensorArray.read(readIndex)]);

          case 67:
            gatherId = getParamValue('tensorArrayId', node, tensorMap, context);
            gatherIndices = getParamValue('indices', node, tensorMap, context);
            gatherDtype = getParamValue('dtype', node, tensorMap, context);
            gatherTensorArray = context.getTensorArray(gatherId.id);
            return _context3.abrupt("return", [gatherTensorArray.gather(gatherIndices, gatherDtype)]);

          case 72:
            scatterId = getParamValue('tensorArrayId', node, tensorMap, context);
            scatterIndices = getParamValue('indices', node, tensorMap, context);
            scatterTensor = getParamValue('tensor', node, tensorMap, context);
            scatterTensorArray = context.getTensorArray(scatterId.id);
            scatterTensorArray.scatter(scatterIndices, scatterTensor);
            return _context3.abrupt("return", [scatterTensorArray.idTensor]);

          case 78:
            concatId = getParamValue('tensorArrayId', node, tensorMap, context);
            concatTensorArray = context.getTensorArray(concatId.id);
            concatDtype = getParamValue('dtype', node, tensorMap, context);
            return _context3.abrupt("return", [concatTensorArray.concat(concatDtype)]);

          case 82:
            splitId = getParamValue('tensorArrayId', node, tensorMap, context);
            splitTensor = getParamValue('tensor', node, tensorMap, context);
            lengths = getParamValue('lengths', node, tensorMap, context);
            splitTensorArray = context.getTensorArray(splitId.id);
            splitTensorArray.split(lengths, splitTensor);
            return _context3.abrupt("return", [splitTensorArray.idTensor]);

          case 88:
            sizeId = getParamValue('tensorArrayId', node, tensorMap, context);
            sizeTensorArray = context.getTensorArray(sizeId.id);
            return _context3.abrupt("return", [scalar(sizeTensorArray.size(), 'int32')]);

          case 91:
            closeId = getParamValue('tensorArrayId', node, tensorMap, context);
            closeTensorArray = context.getTensorArray(closeId.id);
            closeTensorArray.clearAndClose();
            return _context3.abrupt("return", [closeTensorArray.idTensor]);

          case 95:
            idTensor = getParamValue('tensorListId', node, tensorMap, context);
            _index = getParamValue('index', node, tensorMap, context);
            _writeTensor = getParamValue('tensor', node, tensorMap, context);
            tensorList = context.getTensorList(idTensor.id);
            tensorList.setItem(_index, _writeTensor);
            return _context3.abrupt("return", [tensorList.idTensor]);

          case 101:
            _idTensor = getParamValue('tensorListId', node, tensorMap, context);
            _readIndex = getParamValue('index', node, tensorMap, context);
            _elementShape = getParamValue('elementShape', node, tensorMap, context);
            elementDType = getParamValue('elementDType', node, tensorMap, context);
            _tensorList = context.getTensorList(_idTensor.id);
            return _context3.abrupt("return", [_tensorList.getItem(_readIndex, _elementShape, elementDType)]);

          case 107:
            _scatterIndices = getParamValue('indices', node, tensorMap, context);
            _scatterTensor = getParamValue('tensor', node, tensorMap, context);
            _elementShape2 = getParamValue('elementShape', node, tensorMap, context);
            numElements = getParamValue('numElements', node, tensorMap, context);
            _tensorList2 = scatter(_scatterTensor, _scatterIndices, _elementShape2, numElements);
            context.addTensorList(_tensorList2);
            return _context3.abrupt("return", [_tensorList2.idTensor]);

          case 114:
            _elementShape3 = getParamValue('elementShape', node, tensorMap, context);
            elementDtype = getParamValue('elementDType', node, tensorMap, context);

            if (node.op === 'TensorListReserve') {
              numElementsParam = 'numElements';
            } else {
              numElementsParam = 'maxNumElements';
            }

            _numElements = getParamValue(numElementsParam, node, tensorMap, context);
            _tensorList3 = reserve(_elementShape3, elementDtype, _numElements);
            context.addTensorList(_tensorList3);
            return _context3.abrupt("return", [_tensorList3.idTensor]);

          case 121:
            _gatherId = getParamValue('tensorListId', node, tensorMap, context);
            _gatherIndices = getParamValue('indices', node, tensorMap, context);
            _elementShape4 = getParamValue('elementShape', node, tensorMap, context);
            _elementDtype = getParamValue('elementDType', node, tensorMap, context);
            _tensorList4 = context.getTensorList(_gatherId.id);
            return _context3.abrupt("return", [_tensorList4.gather(_gatherIndices, _elementDtype, _elementShape4)]);

          case 127:
            _idTensor2 = getParamValue('tensorListId', node, tensorMap, context);
            _elementShape5 = getParamValue('elementShape', node, tensorMap, context);
            _elementDtype2 = getParamValue('elementDType', node, tensorMap, context);
            _numElements2 = getParamValue('numElements', node, tensorMap, context);
            _tensorList5 = context.getTensorList(_idTensor2.id);
            return _context3.abrupt("return", [_tensorList5.stack(_elementShape5, _elementDtype2, _numElements2)]);

          case 133:
            tensor = getParamValue('tensor', node, tensorMap, context);
            _elementShape6 = getParamValue('elementShape', node, tensorMap, context);
            _elementDtype3 = getParamValue('elementDType', node, tensorMap, context);
            _tensorList6 = fromTensor(tensor, _elementShape6, _elementDtype3);
            context.addTensorList(_tensorList6);
            return _context3.abrupt("return", [_tensorList6.idTensor]);

          case 139:
            _concatId = getParamValue('tensorListId', node, tensorMap, context);
            _tensorList7 = context.getTensorList(_concatId.id);
            _concatDtype = getParamValue('dtype', node, tensorMap, context);
            _elementShape7 = getParamValue('elementShape', node, tensorMap, context);
            return _context3.abrupt("return", [_tensorList7.concat(_concatDtype, _elementShape7)]);

          case 144:
            _idTensor3 = getParamValue('tensorListId', node, tensorMap, context);
            _writeTensor2 = getParamValue('tensor', node, tensorMap, context);
            _tensorList8 = context.getTensorList(_idTensor3.id);

            _tensorList8.pushBack(_writeTensor2);

            return _context3.abrupt("return", [_tensorList8.idTensor]);

          case 149:
            _idTensor4 = getParamValue('tensorListId', node, tensorMap, context);
            _elementShape8 = getParamValue('elementShape', node, tensorMap, context);
            _elementDType = getParamValue('elementDType', node, tensorMap, context);
            _tensorList9 = context.getTensorList(_idTensor4.id);
            return _context3.abrupt("return", [_tensorList9.popBack(_elementShape8, _elementDType)]);

          case 154:
            _splitTensor = getParamValue('tensor', node, tensorMap, context);
            _elementShape9 = getParamValue('elementShape', node, tensorMap, context);
            _lengths = getParamValue('lengths', node, tensorMap, context);
            _tensorList10 = split(_splitTensor, _lengths, _elementShape9);
            context.addTensorList(_tensorList10);
            return _context3.abrupt("return", [_tensorList10.idTensor]);

          case 160:
            throw TypeError("Node type ".concat(node.op, " is not implemented"));

          case 161:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2);
  }));

  return function executeOp(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var CATEGORY = 'control';